// export const API_URL: string = "http://127.0.0.1:5000/"
// export const STATIC_URL: string = "http://127.0.0.1/"

export const API_URL:string = "https://api.aptidext.com/"
export const STATIC_URL:string = "https://static.aptidext.com/"

// export const API_URL:string = "http://192.168.0.168:5000/"
// export const STATIC_URL:string = "http://192.168.0.168:80"
